import React from "react";

const Button = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  loading = false,
  fullWidth = false,
  iconLeft: IconLeft,
  iconRight: IconRight,
}) => {
  const baseStyles =
    "h-[46px] px-6 text-sm font-medium rounded-full transition-all duration-200 flex items-center justify-center gap-2";

  const fullWidthStyles = fullWidth ? "w-full" : "w-auto";

  const variantStyles = {
    primary:
      "bg-[#0A2A4F] text-white hover:bg-[#08305e]",
    secondary:
      "bg-slate-600 text-white hover:bg-slate-700",
    outline:
      "border border-slate-300 text-slate-700 hover:bg-slate-100",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${baseStyles}
        ${fullWidthStyles}
        ${variantStyles[variant]}
        ${(disabled || loading) && "opacity-50 cursor-not-allowed"}
      `}
    >
      {loading ? (
        <span className="animate-pulse">Loading...</span>
      ) : (
        <>
          {IconLeft && <IconLeft size={16} />}
          {label}
          {IconRight && <IconRight size={16} />}
        </>
      )}
    </button>
  );
};

export default Button;
